import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { CarteraService } from 'app/services/cartera/cartera.service';

@Component({
  selector: 'app-add-numero-factura',
  templateUrl: './add-numero-factura.component.html',
  styleUrls: ['./add-numero-factura.component.scss']
})
export class AddNumeroFacturaComponent implements OnInit {

  newForm: FormGroup;

  /**
   *  Constructor
   * @param _data
   * @param {MatDialogRef<AddNumeroFacturaComponent>} _dialog 
   * @param {CarteraService} _cartera 
   * @param {MatSnackBar} _snackBar
   */
  constructor
  ( 
    @Inject(MAT_DIALOG_DATA) private _data,
    public _dialog: MatDialogRef<AddNumeroFacturaComponent>,
    private _cartera: CarteraService,
    private _snackBar: MatSnackBar
  ) 
  { 
    this.newForm = this.createForm();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Creación del FormGroup
   */
  createForm(): FormGroup {
    return new FormGroup({
      factura: new FormControl()
    });
  }

  /**
   * Agrega número de factura al cobro correspondiente
   * @param {any} form 
   */
  public addNFactura(form: any) : void {
    this._cartera.AgregarNumFactura(this._data.cobro, form).subscribe((data: any) => {
      if(data.affectedRows > 0){
        this._snackBar.open('Número de factura añadido', 'Aceptar', {
          duration: 2000
        });
        this._dialog.close(true);
      }else{
        this._snackBar.open('Error al añadir el número de factura', '', {
          duration: 2500,
          panelClass: 'warn-600'
        });
      }
    });
  }



}
